export const useEnv = () => {
  const isClient = ref(import.meta.client)
  return { isClient }
}
